import { CardRequestReasonData } from "../types/cardRequestReason.type";

export class CardRequestReasonsTransformer {
  static optionsTransformer() {
    return (requestReasons: CardRequestReasonData[]) => {
      return requestReasons.map((requestReason) => {
        return {
          label: (
            <div className="flex flex-col gap-1">
              <p>{requestReason.display_name}</p>
              <p className="text-xs text-white-300 font-light italic hidden group-[.select-menu]:block">{requestReason.description}</p>
            </div>
          ),
          value: requestReason.id,
        };
      });
    };
  }
}
